import { useContext, useRef, useState } from 'react';
import { Icon } from '@iconify/react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
    Box,
    Divider,
    MenuItem,
    Typography,
    Avatar,
    IconButton
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { alpha } from '@mui/material/styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';

import MenuPopover from './MenuPopover';
import useAuth from '../../hooks/useAuth';

export default function AccountPopover() {
    const navigate = useNavigate();
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);

    const { user: userData } = useAuth();

    const handleLogout = async () => {
        localStorage.clear();
        navigate('/Login', { replace: true });
    };

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const MENU_OPTIONS = [
        // {
        //     label: 'Home',
        //     icon: HomeIcon,
        //     linkTo: '/dashboard/app/prompt'
        // },
        {
            label: 'Profile',
            icon: PersonIcon,
            linkTo: '/profile'
        }
    ];

    return (
        <>
            <IconButton
                ref={anchorRef}
                onClick={handleOpen}
                sx={{
                    padding: 0,
                    width: 40,
                    height: 40,
                    ...(open && {
                        '&:before': {
                            zIndex: 1,
                            content: "''",
                            width: '100%',
                            height: '100%',
                            borderRadius: '50%',
                            position: 'absolute',
                            bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
                        }
                    })
                }}
            >
                <AccountCircleIcon sx={{ width: 40, height: 40 }} />
            </IconButton>

            <MenuPopover
                open={open}
                onClose={handleClose}
                anchorEl={anchorRef.current}
                sx={{ width: 220 }}
            >
                <Box sx={{ my: 1.5, px: 2.5 }}>
                    <Typography variant="subtitle1" noWrap>
                        {`${userData?.first_name || ''} ${userData?.last_name || ''}`}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                        {userData?.email || ''}
                    </Typography>
                </Box>

                <Divider sx={{ my: 1 }} />

                {MENU_OPTIONS.map((option) => {
                    const IconComponent = option.icon;
                    return (<MenuItem
                        key={option.label}
                        to={option.linkTo}
                        component={RouterLink}
                        onClick={handleClose}
                        sx={{ typography: 'body2', py: 1, px: 2.5 }}
                    >
                        <Box sx={{ mr: 2, width: 24, height: 24, display: 'flex', alignItems: 'center' }}>
                            <IconComponent fontSize="medium" />
                        </Box>
                        {option.label}
                    </MenuItem>);
                })}

                <Box sx={{ p: 2, pt: 1.5 }}>
                    <LoadingButton
                        fullWidth
                        color="inherit"
                        variant="outlined"
                        onClick={handleLogout}
                    >
                        Logout
                    </LoadingButton>
                </Box>
            </MenuPopover>
        </>
    );
}
